export default {"src":"/_next/static/media/delfin.df077a59.gif","height":524,"width":655,"blurWidth":0,"blurHeight":0};